/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var OrderBase;
(function (OrderBase) {
    /**
     * Identifies whether the order has been placed by quantity (kg CO2) or value (monetary amount)
     */
    let type;
    (function (type) {
        type["QUANTITY"] = "quantity";
        type["VALUE"] = "value";
    })(type = OrderBase.type || (OrderBase.type = {}));
    /**
     * Order status
     */
    let status;
    (function (status) {
        status["RECEIVED"] = "received";
        status["PLACED"] = "placed";
        status["PAID"] = "paid";
        status["RETIRING"] = "retiring";
        status["CANCELLED"] = "cancelled";
        status["COMPLETE"] = "complete";
        status["FAILED"] = "failed";
    })(status = OrderBase.status || (OrderBase.status = {}));
})(OrderBase || (OrderBase = {}));
//# sourceMappingURL=OrderBase.js.map